module.exports = __webpack_public_path__ + "img/006.07efc48f.png";